import React from 'react';
import { RenderMembership } from '../../components/renders';

const TableRenderMembershipChip = (column, MEMBERSHIPTS) => rowData => (
  <RenderMembership value={rowData[column]} label={MEMBERSHIPTS[rowData[column]].label} />
);

export default TableRenderMembershipChip;
